import "./style.css";
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { IoCopyOutline, AiOutlineCheckCircle } from "react-icons/all";

function DepositInstructionsEN() {
  const [copied, setCopied] = useState(false);
  const copy = () => setCopied(true);
  const [copied1, setCopied1] = useState(false);
  const copy1 = () => setCopied1(true);
  const [copied2, setCopied2] = useState(false);
  const copy2 = () => setCopied2(true);
  const [copied3, setCopied3] = useState(false);
  const copy3 = () => setCopied3(true);

  const data = [
    {
      bank: "BKT",
      nr: "1906565627031134",
      state: copied,
      copyText: copy,
      link: "https://ebank.bkt-ks.com/ebanking/login.html",
      link1: "https://ebank.bkt-ks.com/ebanking-business/login.html",
    },
    {
      bank: "BPB",
      nr: "1300001002074205",
      state: copied1,
      copyText: copy1,
      link: "https://www.banka-ks.com/BPB/Account/Login",
    },
    {
      bank: "NLB",
      nr: "1701001012338968",
      state: copied2,
      copyText: copy2,
      link: "https://nlb.banka-ks.com/Account/Login",
    },
    {
      bank: "BEK",
      nr: "1401000000737379",
      state: copied3,
      copyText: copy3,
      link: "https://ebanking.bekonomike.com/#/login",
    },
  ];
  return (
    <div id="wrapper-page">
      <div className="deposit_container">
        <div className="row">
          <div className="col-12 deposit_text">
            <h4>
              Issuing of electronic money to your Capital Pay account in several
              ways:
            </h4>
            <h4>
              Top-up of the account without provision in the offices and agents
              of IFJB Capital in over 160 locations throughout Kosovo. IFJB
              Capital will add electronic money as soon as it receives money
              from you. Your funds are safe and at your disposal at any time and
              you can withdraw them whenever you want at any branch or agent of
              IFJB Capital.
            </h4>
            <h5>
              To top up the account, you must have a valid identification
              document such as:
            </h5>
            <ul>
              <li>1. Valid ID, Passport or Driver's License</li>
              <li>
                2. Topping up the account through bank transfer can be done by
                all banks, giving the following description:
                <ul>
                  <li>
                    Phone number and First and Last Name (which you have in the
                    application)
                  </li>
                  <li>
                    For the transfer to be free of charge, consider choosing the
                    same bank as the bank in which you have your account:
                    <ul className="bankat">
                      {data?.map((item) => (
                        <li>
                          <a
                            href={item.link}
                            rel="noreferrer"
                            target="_blank"
                            style={{ color: "#000", textDecoration: "none" }}
                          >
                            {item.bank}: {item.nr}
                          </a>

                          <CopyToClipboard
                            text={item.nr}
                            onCopy={() => item.copyText()}
                          >
                            {item.state ? (
                              <div className="checked">
                                <AiOutlineCheckCircle
                                  style={{ fontSize: 22 }}
                                />
                                Copied to clipboard
                              </div>
                            ) : (
                              <IoCopyOutline
                                style={{ fontSize: 22, cursor: "pointer" }}
                              />
                            )}
                          </CopyToClipboard>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DepositInstructionsEN;
